import React from 'react';

import { SideBarCard } from './styles';
import { Box } from '@mui/material';

export default function CustomSidebarCard({ children }) {
  return (
    <SideBarCard>
      {/** This box is responsible for the text padding, because the container is overflow hidden */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
        }}
      >
        {children}
      </Box>
    </SideBarCard>
  );
}
